import { useEffect, useState } from "react";
import { api } from "./api";

let deferred = null;
const subs = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    subs.forEach((f) => f(true));
  });
}

export function useInstallPrompt() {
  const [can, setCan] = useState(!!deferred);
  useEffect(() => { subs.add(setCan); return () => subs.delete(setCan); }, []);
  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const standalone = window.matchMedia?.("(display-mode: standalone)").matches || navigator.standalone;
  const install = async () => {
    if (!deferred) return false;
    deferred.prompt();
    await deferred.userChoice;
    deferred = null;
    setCan(false);
    return true;
  };
  return { can, install, isIOS, standalone };
}

function b64ToUint8(b64) {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export async function enablePush() {
  if (!pushSupported()) throw new Error("Notifiche push non supportate da questo browser");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso notifiche negato");
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/vapid-public-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToUint8(data.key) });
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return true;
}

export function shareLocation() {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("Geolocalizzazione non supportata"));
    navigator.geolocation.getCurrentPosition(
      async (p) => {
        await api.post("/me/geo", { lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy });
        resolve(true);
      },
      () => reject(new Error("Permesso posizione negato")),
      { enableHighAccuracy: false, timeout: 15000 }
    );
  });
}
